import { CommissionStatus } from '../types/commission-statuses';
import { PillColor } from '../components/Pill/Pill';

export const commissionStatusToTranslationKey = (status: CommissionStatus): string => {
  switch (status) {
    case CommissionStatus.PENDING:
      return 'commission.status.pending';
    case CommissionStatus.ACCEPTED:
      return 'commission.status.accepted';
    case CommissionStatus.REJECTED:
      return 'commission.status.rejected';
    case CommissionStatus.COMPLETED:
      return 'commission.status.completed';
    case CommissionStatus.SOLD:
      return 'commission.status.sold';
    case CommissionStatus.NEW:
      return 'commission.status.new';
    case CommissionStatus.RETURNED_TO_CUSTOMER:
      return 'commission.status.returned_to_customer';
    default:
      return 'commission.status.unknown';
  }
};

export const commissionStatusToAbbreviatedTranslationKey = (status: CommissionStatus): string => {
  switch (status) {
    case CommissionStatus.PENDING:
      return 'commission.status.pending.short';
    case CommissionStatus.ACCEPTED:
      return 'commission.status.accepted.short';
    case CommissionStatus.REJECTED:
      return 'commission.status.rejected.short';
    case CommissionStatus.COMPLETED:
      return 'commission.status.completed.short';
    case CommissionStatus.SOLD:
      return 'commission.status.sold.short';
    case CommissionStatus.NEW:
      return 'commission.status.new.short';
    case CommissionStatus.RETURNED_TO_CUSTOMER:
      return 'commission.status.returned_to_customer.short';
    default:
      return 'commission.status.unknown.short';
  }
};

export const commissionStatusToPillColor = (status: CommissionStatus): PillColor => {
  switch (status) {
    case CommissionStatus.PENDING:
      return 'yellow';
    case CommissionStatus.ACCEPTED:
      return 'green';
    case CommissionStatus.REJECTED:
      return 'red';
    case CommissionStatus.COMPLETED:
      return 'blue';
    case CommissionStatus.SOLD:
      return 'purple';
    case CommissionStatus.NEW:
      return 'blue';
    case CommissionStatus.RETURNED_TO_CUSTOMER:
      return 'orange';
    default:
      return 'grey';
  }
}; 